import { AgentWidget } from '@salescore/client-feature-agent'
import { selectPickedViewId, selectPickedViewIds, selectSiderViews, useAppSelector } from '@salescore/client-redux'
import type { ReactElement } from 'react'

import { viewTabsOf } from '../viewTabs'

/**
 * 画面右下のエージェントのウィジェットに、今開いている view（会話の対象の候補）を渡す。
 * view を移るたびの描き直しを、MemberLayoutBase 全体ではなくウィジェットの周りに留めるため、別の部品にしている
 */
export const AgentWidgetContainer = ({
  organizationId,
  isViewRelated,
  defaultOpenViewIds,
}: {
  organizationId: string
  // view の画面（/o/$organizationId/v2/）を開いているか。選んだ view の id は localStorage に残るので、ほかの画面では開いている view はない
  isViewRelated: boolean
  // 組織の設定で、view の画面に最初から開く view。選んだ view がないときは、この先頭が画面に出る
  defaultOpenViewIds: readonly string[]
}): ReactElement => {
  const siderViews = useAppSelector(selectSiderViews)
  const pickedViewId = useAppSelector(selectPickedViewId)
  const pickedViewIds = useAppSelector(selectPickedViewIds)
  const { shownView } = viewTabsOf({ siderViews, pickedViewId, pickedViewIds, defaultOpenViewIds })

  return <AgentWidget organizationId={organizationId} openView={isViewRelated ? (shownView ?? null) : null} />
}
